var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('CouponPopupNotLogged',{attrs:{"dataSource":_vm.configData,"show":_vm.show,"closeOnClickOverlay":false,"page":_vm.trackPage,"buttonValue":"banner"},on:{"close":_vm.closePopup}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }